export default __webpack_public_path__ + "static/media/flyerBg.d25096b4.jpg";